import { useI18n } from 'vue-i18n';

import { useRuntimeConfig } from '~coreModules/core/js/composables/useRuntimeConfig';
import { useUserState } from '~coreModules/core/js/composables/useUserState';
import { useGetters } from '~coreModules/core/js/composables/vuexHelpers';
import useMeta from '~coreModules/core/js/seo/composables/use-meta';

export default function useHomepageMeta() {
    const { t } = useI18n();
    const runtimeConfig = useRuntimeConfig();
    const userState = useUserState();

    const { loggedIn, appBaseUrl } = useGetters(['loggedIn', 'appBaseUrl']);

    const { homepageTitle, homepageDescription, homepageOGTitle, homepageOGDescription } = runtimeConfig.siteMeta;

    function getPageTitle() {
        return t(homepageTitle);
    }

    function getMetaTags() {
        return [{
            name: 'description',
            content: t(homepageDescription),
        }, {
            property: 'og:title',
            content: t(homepageOGTitle),
        }, {
            property: 'og:description',
            content: t(homepageOGDescription),
        }];
    }

    function getLinkTags() {
        return [{
            rel: 'canonical',
            href: `${userState.baseUrl}${loggedIn.value ? appBaseUrl.value : '/'}`,
        }];
    }

    useMeta({ getMetaTags, getPageTitle, getLinkTags });
}
